import {IMacronutrientDistributionValues} from './interfaces/macronutrient-distribution-values.interface';
import {DistributionPropertyLt} from './classes/distribution-property-lt';
import {DistributionPropertyG} from './classes/distribution-property-g';
import {DistributionPropertyPercentage} from './classes/distribution-property-percentage';
import {MacronutrientDistribution} from './macronutrient-distribution';

export class OmsStrategy extends MacronutrientDistribution {
  water: DistributionPropertyLt;
  constructor() {
    super();
    this.carbohydrates = new DistributionPropertyPercentage('H. de carbono', { minimum: 55, maximum: 65 }, 55, 'icons8-trigo-50.png');
    this.lipids = new DistributionPropertyPercentage('Grasas', { minimum: 30 }, 30, 'icons8-sashimi-50.png');
    this.protein = new DistributionPropertyPercentage('Proteínas', { minimum: 15 }, 15, 'icons8-filete-50.png');
    this.fiber = new DistributionPropertyG('Fibra', 25, 0, 'icons8-hoja-50.png');
  }

  init(value: IMacronutrientDistributionValues): void {
    // suma de gramos
    const total = value.carbohydrate_g + value.dietaryFiber_g + value.totalFat_g + value.protein_g;

    this.carbohydrates.setValue(
      value.carbohydrate_g > 0 ?
        Math.round(((value.carbohydrate_g * 100) / total)) :
        55
    );
    this.lipids.setValue(
      value.totalFat_g > 0 ?
        Math.round(((value.totalFat_g * 100) / total)) :
        30
    );
    this.protein.setValue(
      value.protein_g > 0 ?
        Math.round(((value.protein_g * 100) / total)) :
        15
    );
    this.fiber.setValue(
      value.dietaryFiber_g > 0 ?
        Math.round(((value.dietaryFiber_g * 100) / total)) :
        0
    );
  }
}
